class FormField {
  constructor({
    id,
    gid, //incase []
    type, //[ String, Number, Integer, Boolean, Array, Object, Array's object ]
    required,
    unique,
    section,
    name,
    desc,
    placeholder,
    element_type, //[ Text, TextArea, DatePicker, Single-Select, Multi-Select, File, Hidden ]
    format, //[ Date-Time, Date, Email, URL, MSISDN ]
    pattern,
    min_length,
    max_length,
    minimum,
    maximum,
    logic,
    initial_value,
    source,
    trigger, //example: List [ "postcode_id" ]
    is_cascade,
    i18n,
    values,
  }) {
    this.id = id;
    this.gid = gid; //incase []
    this.type = type; //[ String, Number, Integer, Boolean, Array, Object, Array's object ]
    this.required = required;
    this.unique = unique;
    this.section = section;
    this.name = name;
    this.desc = desc;
    this.placeholder = placeholder;
    this.element_type = element_type; //[ Text, TextArea, DatePicker, Single-Select, Multi-Select, File, Hidden ]
    this.format = format; //[ Date-Time, Date, Email, URL, MSISDN ]
    this.pattern = pattern;
    this.min_length = min_length;
    this.max_length = max_length;
    this.minimum = minimum;
    this.maximum = maximum;
    this.logic = logic;
    this.initial_value = initial_value;
    this.source = source;
    this.trigger = trigger; //example: List [ "postcode_id" ]
    this.is_cascade = is_cascade;
    this.i18n = i18n;
    this.values = values; //value for input array
  }
}
export default FormField;
